import React, { useCallback, useMemo, useEffect, useState } from "react";

import { useSelector } from "react-redux";
import { toastr } from "react-redux-toastr";
import { createEditor, Editor, Transforms } from "slate";
import { withHistory } from "slate-history";
import {
  Slate,
  Editable,
  useSelected,
  useFocused,
  withReact
} from "slate-react";

import FunctionsMenu from "./FunctionsMenu";
import InsertingModal from "./InsertingModal";
import URL$1 from "../../../config/api";
import "./styles.css";
import axios from "../../../config/axios";

const Input = props => {
  const [imageImporter, setImageImporter] = useState(false);
  const [itemMenuFocus, setItemMenuFocus] = useState(false);
  const user = useSelector(state => state.user);
  const userId = user.user.id;

  // useEffect(() => {
  //   editor.selection = {
  //     anchor: { path: [0, 0], offset: 0 },
  //     focus: { path: [0, 0], offset: 0 }
  //   };
  // }, [props.clearCursor]);

  const withImages = editor => {
    const { insertData, isVoid } = editor;

    editor.isVoid = element =>
      element.type === "image" ? true : isVoid(element);

    editor.insertData = async data => {
      const text = data.getData("text/plain");
      const { files } = data;

      if (files && files.length > 0) {
        const imageURL = await uploadPasteImage(files[0]);
        insertImage(editor, imageURL);
      } else {
        insertData(data);
      }
    };

    return editor;
  };

  const uploadPasteImage = async file => {
    const formData = new FormData();
    formData.append("file0", file);

    try {
      const imageUploadResponse = await axios.post(
        `${URL$1.api}file/question_images/${userId}`,
        formData,
        {
          headers: {
            authorization: `Bearer ${user.token}`,
            "Content-Type": "multipart/form-data"
          }
        }
      );

      return URL$1.img + imageUploadResponse.data.files[0].url;
    } catch (error) {
      toastr.error("Erro", "Erro ao enviar imagem");
    }
  };

  const insertImage = (editor, src) => {
    const text = { text: "" };
    const image = { type: "image", url: src, children: [text] };
    Transforms.insertNodes(editor, image);

    const lineBreak = { type: "paragraph", children: [text] };
    Transforms.insertNodes(editor, lineBreak);
  };

  let ImageElement = ({ attributes, children, element }) => {
    const selected = useSelected();
    const focused = useFocused();
    return (
      <div {...attributes}>
        <div contentEditable={false} className="d-flex justify-content-center">
          <img
            alt=""
            src={element.url}
            className="d-block rounded"
            style={{
              maxHeight: "20em",
              maxWidth: "100%",
              boxShadow: selected && focused ? "0 0 0 3px #B4D5FF" : "none"
            }}
          />
        </div>
        {children}
      </div>
    );
  };

  const toggleMark = (e, editor, format) => {
    e.preventDefault();

    const isActive = isMarkActive(editor, format);

    if (isActive) {
      Editor.removeMark(editor, format);
    } else {
      Editor.addMark(editor, format, true);
    }
  };

  const isMarkActive = (editor, format) => {
    const marks = Editor.marks(editor);
    return marks ? marks[format] === true : false;
  };

  let Leaf = ({ attributes, children, leaf }) => {
    if (leaf.bold) {
      children = <strong>{children}</strong>;
    }

    if (leaf.italic) {
      children = <em>{children}</em>;
    }

    if (leaf.underline) {
      children = <u>{children}</u>;
    }

    return <span {...attributes}>{children}</span>;
  };

  const renderLeaf = useCallback(props => <Leaf {...props} />, []);

  let Element = props => {
    const { attributes, children, element } = props;

    switch (element.type) {
      case "image":
        return <ImageElement {...props} />;
      default:
        return <div {...attributes}>{children}</div>;
    }
  };

  const renderElement = props => <Element {...props} />;

  const showImageImporterModal = () => {
    setImageImporter(true);
  };

  const hideImageImporterModal = () => {
    setImageImporter(false);
  };

  const editor = useMemo(
    () => withImages(withHistory(withReact(createEditor()))),
    []
  );

  return (
    <>
      <div className={`form-control h-auto ${props.className || ""}`}>
        <Slate
          editor={editor}
          value={props.value}
          onChange={newValue => {
            props.onChange(newValue);
          }}
        >
          {!props.readOnly && (
            <InsertingModal
              insertImage={insertImage}
              editorAcces={editor}
              show={imageImporter}
              hideImageImporter={hideImageImporterModal}
            />
          )}
          <Editable
            className={`${props.editableClassName || ""}`}
            renderElement={renderElement}
            renderLeaf={renderLeaf}
            readOnly={props.readOnly}
            placeholder={props.placeholder}
            // onFocus={() => {
            //   setItemMenuFocus(true);
            // }}
            // onBlur={() => setTimeout(() => setItemMenuFocus(false), 200)}
          />
          {!props.readOnly && !props.hideMenu && (
            <FunctionsMenu
              showItemMenu={itemMenuFocus}
              editorAcces={editor}
              toggleMark={toggleMark}
              showImageImporter={showImageImporterModal}
            />
          )}
        </Slate>
      </div>
    </>
  );
};

export default Input;
